const hasCoordinate = value => (
  value !== null && value !== undefined && value !== ''
)

export const resolveAssetCoordinates = asset => {
  const latitude = hasCoordinate(asset?.address?.lat)
    ? asset.address.lat
    : asset?.geo?.lat
  const longitude = hasCoordinate(asset?.address?.long)
    ? asset.address.long
    : asset?.geo?.long

  if (!hasCoordinate(latitude) || !hasCoordinate(longitude)) {
    return null
  }

  return `${latitude},${longitude}`
}
